"use client"

import { useEffect } from "react"

/**
 * Publishes fixed header height on `<html>` so portaled overlays (ScrollDialog, …)
 * can size and center below the site header. Pass `undefined` to leave unset.
 */
export default function useSiteHeaderHeight(height: string | null | undefined) {
  useEffect(() => {
    if (height === undefined) {
      return
    }

    const root = document.documentElement

    if (height === null) {
      root.style.removeProperty("--header-height")
      return () => {
        root.style.removeProperty("--header-height")
      }
    }

    root.style.setProperty("--header-height", height)
    return () => {
      root.style.removeProperty("--header-height")
    }
  }, [height])
}
